import * as React from 'react'

import { Box, Spinner } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ExpensesDataCollection } from 'modules/expenses/components/expenses/DataCollection/ExpensesDataCollection'
import { useExpensesListPage } from 'modules/expenses/hooks/useExpensesListPage'
import { Group } from 'modules/expenses/hooks/useGroup'
import { usePayroll } from 'modules/expenses/hooks/usePayroll'
import { useExpenses } from 'modules/expenses/pages/ExpensesContext'

export interface ListProps {
  group?: Group
  back: { href: string }
  onAddUsers?: () => void
}

const List = ({ group, back, onAddUsers }: React.PropsWithChildren<ListProps>) => {
  const { company } = useCurrentSession()

  const {
    data,
    featureAvailabilities: { reimburseThroughPayroll, compensationsEnabled },
  } = useExpenses()

  const { canSeeTransactions, loading, policyFlagsEnabled } = useExpensesListPage({
    companyId: company.id,
  })

  const { categories: availableCategories, currentPeriodOpen: currentPayrollPeriodOpen } =
    usePayroll(reimburseThroughPayroll, compensationsEnabled, data.payroll, data.compensations)

  if (loading) {
    return (
      <Box paddingY="s32" paddingX="s48" justifyContent="center" alignItems="center" width="full">
        <Spinner />
      </Box>
    )
  }

  return (
    <ExpensesDataCollection
      back={back}
      companyId={company.id}
      canSeeTransactions={canSeeTransactions}
      onAddUsers={onAddUsers}
      currentPayrollPeriodOpen={currentPayrollPeriodOpen}
      availablePayrollCategories={availableCategories || []}
      group={group}
      policyFlagsEnabled={policyFlagsEnabled}
    />
  )
}

export default observer(List)
